import { useEffect, useRef, useState } from "react";
import "./App.css";
import { useLocation, useNavigate } from "react-router-dom";
import RouteComponent from "./Router/RouteComponent";
import ScrollToTop from "./scrolltotop";
import Header from "./Components/Header";
import Sidebar from "./Components/Sidebar";
import { RoutesPaths } from "./Router/constant";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { verifyTokenAPI } from "./Services/authService";
import { handleTokenVerification } from "./Utils/authUtils";

function App() {
  const sidebarRef = useRef(null);
  const headerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [showSidebar, setShowSidebar] = useState(false);
  const [role, setUserRole] = useState(null); // ✅ FIXED

  const [isSidebarHeaderEnabledState, SetisSidebarHeaderEnabledState] =
    useState(false);

  useEffect(() => {
    SetisSidebarHeaderEnabledState(
      [RoutesPaths.SIGNIN, RoutesPaths.RESET_PASSWORD].includes(location.pathname)
    );
  }, [location.pathname]);

  // ✅ TOKEN VERIFICATION
  useEffect(() => {
    const publicPaths = [
      RoutesPaths.SIGNIN,
      RoutesPaths.RESET_PASSWORD
    ]; if (publicPaths.includes(location.pathname)) return;

    const checkToken = async () => {
      try {
        const res = await verifyTokenAPI();
        const role = res?.data?.data?.role;
        const partnerId = res?.data?.data?.partner?._id;
        const serviceTypes = res?.data?.data?.partner?.serviceTypes;

        if (role) {
          localStorage.setItem("userRole", role);
          localStorage.setItem("partnerId", partnerId);
          localStorage.setItem("serviceTypes", serviceTypes);

          setUserRole(role); // ✅ IMPORTANT FIX
        }

        const isValid = res?.data && Object.keys(res.data).length > 0;
        if (!isValid) {
          await handleTokenVerification(navigate);
        }
      } catch (error) {
        await handleTokenVerification(navigate);
      }
    };

    checkToken();
  }, [location.pathname, navigate]);

  // ✅ FALLBACK: read from localStorage (refresh case)
  useEffect(() => {
    if (!role) {
      const storedRole = localStorage.getItem("userRole");
      setUserRole(storedRole);
    }
  }, [role]);

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        headerRef.current &&
        !headerRef.current.contains(event.target)
      ) {
        setShowSidebar(false);
      }
    };

    if (showSidebar) {
      document.addEventListener("click", handleClickOutside, true);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [showSidebar]);

  useEffect(() => {
    setShowSidebar(false);
  }, [location.pathname]);

  const { pathname } = useLocation();

  useEffect(() => {
    const el = document.getElementById("app-scroll-container");
    if (el) {
      el.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return (
    <>
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={3000} />

      {isSidebarHeaderEnabledState ? (
        <div className="container-fluid">
          <RouteComponent />
        </div>
      ) : (
        <div className="container-fluid p-0">
          <div className="dashboardStructureSection">
            <div
              ref={sidebarRef}
              className={`p-0 sideBarStructure 
                ${showSidebar ? "show" : ""} 
                ${role === "partner" ? "partnerSidebar" : ""}`}
            >
              <Sidebar />
            </div>

            <div className="detailsStructure">
              <Header ref={headerRef} onHeaderClick={toggleSidebar} />
              <div className="detailsStructureBottom" id="app-scroll-container">
                <RouteComponent />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
